export const AddressProvider = {
  Google: "google",
  AI: "ai"
}